
export const ParentTipsSection = () => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">Tips for Parents & Teachers</h2>
          <p className="text-xl text-gray-600">
            Get the most out of Bobo & Teedee® activities with these helpful suggestions!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600&h=400&fit=crop" 
              alt="Parent and child doing activities together"
              className="w-full h-80 object-cover rounded-2xl shadow-xl"
            />
          </div>
          
          <div className="space-y-6">
            <div className="bg-teedee-blue/10 p-6 rounded-2xl">
              <h3 className="text-xl font-bold text-teedee-blue mb-3">Make It Interactive</h3>
              <p className="text-gray-600">
                While completing activities, ask children about what they remember from the episodes. Connect the activities to real-life experiences and Cayman Islands culture.
              </p>
            </div>

            <div className="bg-bobo-green/10 p-6 rounded-2xl">
              <h3 className="text-xl font-bold text-bobo-green mb-3">Encourage Discussion</h3>
              <p className="text-gray-600">
                Use activity time to discuss the values and lessons from Bobo & Teedee® episodes. Ask children how they can apply kindness and friendship in their daily lives.
              </p>
            </div>

            <div className="bg-brand-purple/10 p-6 rounded-2xl">
              <h3 className="text-xl font-bold text-brand-purple mb-3">Create Together</h3>
              <p className="text-gray-600">
                Many activities are perfect for family time! Work on coloring pages, quizzes, and games together to strengthen family bonds while learning.
              </p>
            </div>

            <div className="bg-golden-orange/10 p-6 rounded-2xl">
              <h3 className="text-xl font-bold text-golden-orange mb-3">Celebrate Achievements</h3>
              <p className="text-gray-600">
                Display completed artwork, celebrate quiz achievements, and acknowledge when children demonstrate the values learned through activities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
